// extracted by mini-css-extract-plugin
module.exports = {"prev":"Previous_prev__nRln6"};